import React, { Component } from 'react';
import { connect } from "react-redux";

import { Row, Col } from 'reactstrap';

import * as actions from '../../actions/ApiActions';

import NumberedItem from '../../components/NumberedItem/NumberedItem'
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import Content from "../../components/Content/Content";
import ContactForm from '../../components/ContactForm/ContactForm';
import LogoCarousel from '../../components/LogoCarousel/LogoCarousel';

class PatientsContainer extends Component {
  constructor(props) {
    super(props);

    this.doctorRef = React.createRef();
    this.patientRef = React.createRef();
  }

  render() {

    const {sendContactMessage} = this.props;

    return (
      <div>
        <Section pattern header>
          <Headline pageTitle>
            In drei Klicks zu Ihrem Arzttermin.
          </Headline>
          <Headline center subtitle>Kurzfristig, ohne Anmeldung und natürlich kostenlos!</Headline>
        </Section>
        <div>

          <Section triangle>

            <Row style={{marginTop: '-220px'}}>
              <Col lg={4}>
                <img style={{marginBottom: '40px', height: '269px', width: 'auto'}} className={'avatar'} src={'/img/avatars/Patient-1.png'} />
                <Headline center>Suchen</Headline>
                <p>Wählen Sie das Fachgebiet des Arztes
                  sowie den Ort oder die Region aus, in
                  dem Sie einen Arzt suchen. Teilen
                  Sie uns anschließend das gewünschte
                  Datum für Ihren Arzttermin mit. </p>
              </Col>
              <Col lg={4}>
                <img style={{marginBottom: '40px', height: '269px', width: 'auto'}} className={'avatar'} src={'/img/avatars/Patient-2.png'} />
                <Headline center>Finden</Headline>
                <p>Nun sehen Sie die Termine, die am
                  besten zu Ihren Kriterien passen. Unter
                  „Termindetails“ können Sie ganz
                  einfach genauere Informationen zum
                  Termin und Arzt einsehen.</p>
              </Col>
              <Col lg={4}>
                <img style={{marginBottom: '40px', height: '269px', width: 'auto'}} className={'avatar'} src={'/img/avatars/Patient-3.png'} />
                <Headline center>Buchen</Headline>
                <p>Haben Sie Ihren Termin gefunden,
                  brauchen wir lediglich Ihren Namen,
                  Ihre Emailadresse und Mobilnummer.
                  Zum Schluss den Termin per Email
                  bestätigen, fertig!</p>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <Button style={{marginTop: '40px'}} center href={'/'}>Jetzt Termin finden</Button>
              </Col>
            </Row>

          </Section>

          <Section>
            <Headline>Unsere Partner und Unterstützer</Headline>
            <LogoCarousel>
              <img src="/img/avatars/logos/logo1.png" />
              <img src="/img/avatars/logos/logo2.png" />
              <img src="/img/avatars/logos/logo3.png" />
              <img src="/img/avatars/logos/logo4.png" />
              <img src="/img/avatars/logos/logo5.png" />
              <img src="/img/avatars/logos/logo6.png" />
              <img src="/img/avatars/logos/logo7.png" />
              <img src="/img/avatars/logos/logo8.png" />
              <img src="/img/avatars/logos/logo9.png" />
            </LogoCarousel>
          </Section>

          <Section grey>
            <Row>
              <Col md={5} xs={12}>
                <Headline>Haben Sie noch Fragen?</Headline>
                <Headline small>Dann kommen Sie mit uns in Kontakt.</Headline>
                <ContactForm sendAction={(body) => sendContactMessage(body)} />
              </Col>

              <Col md={{ size: 5, offset: 1 }} xs={12}>
                <div style={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'flex-end', flexDirection: 'column' }}>
                  <Headline>Bekannt aus:</Headline>
                  <img src={'/img/bekannt-aus.png'} />
                </div>
              </Col>
            </Row>

          </Section>

        </div>
      </div>
    )
  }
}

export default connect(null, actions)(PatientsContainer);



// WEBPACK FOOTER //
// ./src/container/public/PatientsContainer.js